$(document).ready(function () {
    'use strict';

    //..navbar mobile-menu js start..//
    $(window).on('scroll', function () {
        var scrolling = $(this).scrollTop()
        if (scrolling > 32) {
            $('.navbar-wrapper-main').addClass('nav-fixed')
        } else {
            $('.navbar-wrapper-main').removeClass('nav-fixed')
        }

    })
    

    // $('.categorie-items-area').on('scroll', function () {
    //     var scrollTop = $(this).scrollTop();
    //     scrollLink.each(function () {
    //         var sectionhead = $(this.hash).offset().top - 85;
    //         if (scrollTop >= sectionhead) {
    //             $(this).parent().addClass('active');
    //             $(this).parent().siblings().removeClass('active');
    //         }
    //     });
    // })

    $(".ham-menu").click(function (event) {
        event.stopPropagation();
        $(".mobile-menu-wrapper").toggleClass("active");
        $(".ham-menu").toggleClass("active");
    });

    $('.mobile-drop-down-menu').on('click', function () {
        $(this).children(".mobile-drop-down-menu-wrapper").slideToggle();
        $(this).children(".drop-down-menu-btn").toggleClass('active');
    });
    //..navbar mobile-menu js end..//

    //..search bar js start..//
    $(".search-open").click(function (event) {
        event.stopPropagation();
        $(".search-bar").addClass('active');
    });

    $(".search-bar-close").click(function (event) {
        event.stopPropagation();
        $(this).parent().removeClass('active');
    });
    //..search bar js end..//

    // **..categorie js start..**
    $('.categorie-item-list-link').on('click', function () {
        // $(this).next().slideToggle();
        $('.categorie-item-list-link').removeClass('active');
        $(this).addClass('active');
    });

    
    //scroll-spy & Smooth-scrolling
    var scrollLink = $('.scroll-link');
    $(scrollLink).on('click', function (event) {
        event.preventDefault();
        $('html,body').animate({
            scrollTop: $(this.hash).offset().top - 80
        }, 1000);
    });
    // **..categorie js end..**

    // **..accordion js start..**
    $('.accordion-item-title').on('click', function () {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active');
    });
    // **..accordion js end..**

    // --tab js start--
    $('.tab-nav-item:first-child').addClass('active');
    $('.tab-content-item').hide();
    $('.tab-content-item:first').show();

    $('.tab-nav-item').click(function () {
        $('.tab-nav-item').removeClass('active');
        $(this).addClass('active');
        $('.tab-content-item').hide();

        var activeTab = $(this).find('a').attr('href');
        $(activeTab).fadeIn();
        return false;
    });
    // --tab js end--

    // tab content item scroll js start---
    $(".tab-content-items").niceScroll();
    // tab content item scroll js start---
})

// product slider js start--
var swiper = new Swiper(".product-slider", {
    spaceBetween: 30,
    slidesPerView: 4,
    grabCursor: true,
    loop: true,
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        // when window width is >= 320px
        1: {
            slidesPerView: 1,
        },
        // when window width is >= 480px
        576: {
            slidesPerView: 2,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 4,
        }
    }
});
// product slider js end--

// content animation--
new WOW().init();